import apiApp from "./index";
const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
    return decodedToken?.isMultitenancy && decodedToken?.subTenantId
        ? { id: decodedToken.subTenantId }
        : null;
};

// Common headers
const getHeaders = () => {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };

    // only tenant-admin OR if subTenantId is missing
    if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
        headers["tenant-login"] = true;
    }

    return headers;
};

const ShelfLifeAnalysisApi = {
    // Create Shelf Life Analysis Api
    CreateShelfLifeAnalysis: (data) => {
        const jsonData = JSON.parse(data);
        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

        const headers = {
            Authorization: `Bearer ${token}`,
            "x-Authorization": `${decodedToken?.tenantApiKey}`,
        };
        return new Promise((resolve, reject) => {
            apiApp
                .post(`/shelfLifeAnalysis`, jsonData, {
                    headers: headers,
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    // Upload Shelf Life Analysis Document
    UploadShelfLifeDocument: (shelfLifeAnalysisId, file) => {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("file", file);

            const url = `/shelf-life-analysis/file-resources/uploads?tenantId=${decodedToken?.tenantId}&userId=${decodedToken?.userId}&selected=true&shelfLifeAnalysisId=${shelfLifeAnalysisId}${getSubTenantIdParam()}`;

            apiApp
                .post(url, formData, {
                    headers: {
                        ...getHeaders(),
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response?.data || error);
                });
        });
    },

    // List Shelf Life Analysis Api
    ListshelfLifeAnalysisProduction: (ShelfLifeID) => {
        return new Promise((resolve, reject) => {
            apiApp
                .get(`/shelfLifeAnalysis/production/${ShelfLifeID}?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
                    headers: getHeaders(),
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    ListshelfLifeAnalysisProduct: (productId) => {
        return new Promise((resolve, reject) => {
            apiApp
                .get(`/shelfLifeAnalysis/product/${productId}?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
                    headers: getHeaders(),
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },


    // List Shelf Life Analysis Api
    ListshelfLifeAnalysis: () => {
        return new Promise((resolve, reject) => {
            apiApp
                .get(`/shelfLifeAnalysis?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
                    headers: getHeaders(),
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    // Delete shelf Life Analysis Api
    DeleteshelfLifeAnalysis: (ShelfLifeID) => {
        return new Promise((resolve, reject) => {
            apiApp
                .delete(
                    `/shelfLifeAnalysis/${ShelfLifeID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    {
                        headers: getHeaders(),
                    }
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

};

export default ShelfLifeAnalysisApi;
